define('modules/admin/vendors/views/vendors',['require','jQuery','utils/AdminUtils','models/sessionUser','T1','T1Layout','T1View','text!../templates/vendors.html','models/userPreferences','collections/vendorsAdmin','When','T1Signature'],function (require) {
  "use strict";

  const $ = require("jQuery");
  const AdminUtils = require("utils/AdminUtils");
  const SessionUser = require("models/sessionUser");
  const T1 = require("T1");
  const T1Layout = require("T1Layout");
  const T1View = require("T1View");
  const tmpl = require("text!../templates/vendors.html");
  const UserPreferences = require("models/userPreferences");
  const Vendors = require("collections/vendorsAdmin");
  const When = require("When");
  const T1Signature = require("T1Signature");
  return T1View.extend({
    template: tmpl,
    userPreferenceViewName: "vendor",
    isActive: "true",
    subFilterValue: "ALL",
    eventhubEvents: {
      "change:itemSelectedChange": function () {
        this.toggleBulkAction();
      },
      "search:onSearchRequest": function (args) {
        this.collection.searchTerm = args.value.length > 0 ? args.value : undefined;
        if (this.searchTerm === this.collection.searchTerm) {
          return;
        }
        this.searchTerm = this.collection.searchTerm;
        this.filterCollection(args.field, args.value);
      },
      "search:clearSearchClicked": function (args) {
        var coll = this.collection;
        coll.refreshOnNextFetch();
        coll.searchTerm = this.searchTerm = undefined;
        this.filterCollection(args.field, args.value);
      },
      "search:toggleActive": function (args) {
        this.filterCollection("is_eligible", args.value);
        this.isActive = args.value === "1" ? "true" : "false";
        this.preferences.save();
      },
      "search:subFilterChanged": function (args) {
        this.filterCollection("vendor_type", args.value);
        this.subFilterValue = args.value;
        this.preferences.save();
      }
    },
    events: {
      "changed .choose-action": "onChooseActionChange",
      "click .add-vendor": "addVendor"
    },
    viewChanged: false,
    initialize() {
      var signature = T1.Signature.create();
      signature.set(new Map([["root", "ui"], ["module", "admin.search"], ["view", this.userPreferenceViewName]]));
      this.preferences = T1.Preferences.create.call(this, signature, UserPreferences);
      this.preferences.mark(["isActive", "subFilterValue"]);
      this.isActive = this.preferences.get("isActive");
      this.isActive = this.isActive !== undefined ? this.isActive : "true";
      this.subFilterValue = this.preferences.get("subFilterValue");
      this.subFilterValue = this.subFilterValue !== undefined ? this.subFilterValue : "ALL";
      this.sessionUser = SessionUser.getUser();
      this.userType = this.sessionUser.get("type");
      this.collection = new Vendors();
      this.collection.applySearchFilter("is_eligible", this.isActive === "true" ? "1" : "");
      this.collection.applySearchFilter("vendor_type", this.subFilterValue === "ALL" ? "" : this.subFilterValue);
      this.initLayout();
    },
    addVendor() {
      T1.Location.set("admin/vendor", {});
    },
    initLayout() {
      var listLayout = {
        ".list-search": [{
          module: "admin/shared",
          viewType: "search",
          options: {
            searchInputPlaceHolder: "Type Name or ID Number",
            isActiveChecked: this.isActive === "true",
            subFilter: {
              name: "Type",
              defaultValue: this.subFilterValue,
              value: [{
                name: "All",
                value: "ALL"
              }, {
                name: "Data",
                value: "DATA"
              }, {
                name: "Ad Server",
                value: "AD_SERVER"
              }, {
                name: "Ad Verification",
                value: "AD_VERIFICATION"
              }, {
                name: "Survey",
                value: "SURVEY"
              }, {
                name: "Dynamic Creative",
                value: "DYNAMIC_CREATIVE"
              }, {
                name: "Privacy Compliance",
                value: "OBA_COMPLIANCE"
              }, {
                name: "Audience Verification",
                value: "AUDIENCE_VERIFICATION"
              }, {
                name: "Measurement",
                value: "MEASUREMENT"
              }, {
                name: "Contextual",
                value: "CONTEXTUAL"
              }, {
                name: "Viewability",
                value: "VIEWABILITY"
              }, {
                name: "Other",
                value: "OTHER"
              }]
            }
          }
        }],
        ".w-grid": [{
          module: "admin/vendors",
          viewType: "grid",
          options: {
            collection: this.collection,
            vendors: this
          }
        }]
      };
      this.layout = new T1Layout({
        el: () => this.el,
        selectorPath: ".list-body",
        template: '<div class="w-grid"></div>',
        layout: listLayout
      });
    },
    load() {
      this.render().then(() => {
        if (this.layout) {
          this.layout.load();
        }
      });
    },
    unload() {
      var searchFieldVal = this.collection.searchTerm;
      this.viewChanged = true;
      this.collection.searchTerm = this.searchTerm = null;
      if (searchFieldVal && searchFieldVal !== "") {
        this.collection.applySearchFilter(searchFieldVal.indexOf("#") !== -1 ? "name|id" : "multiField", "");
      }
    },
    filterCollection(field, term) {
      var $chooseAction = this.$(".choose-action");
      T1.EventHub.publish("vendorGrid:reload");
      this.collection.filterBy(field, term, function () {
        $chooseAction.attr("disabled", true);
      });
    },
    toggleBulkAction() {
      var self = this;
      var selected = this.collection.getSelected();
      var $chooseAction = this.$(".choose-action");
      $chooseAction.attr("disabled", true);
      if (selected.length) {
        $.each(selected.models, function (i, model) {
          var perms = AdminUtils.checkUserPermissions(self.sessionUser, model);
          if (perms.canActivate || perms.canDeactivate) {
            $chooseAction.attr("disabled", false);
          }
        });
      }
    },
    onChooseActionChange(evt) {
      var $button = this.$(".choose-action");
      var val = $button.val();
      if (val === "active") {
        this.bulkAction({
          is_eligible: "1"
        });
        evt.target.async(evt.target.reset);
      }
      if (val === "inactive") {
        this.bulkAction({
          is_eligible: "0"
        });
        evt.target.async(evt.target.reset);
      }
    },
    bulkAction(modelValues) {
      var self = this;
      var queue = [];
      var selected = this.collection.getSelected();
      var entityType = "Vendor";
      selected.each(function (model) {
        var loader = self.createInlineLoader(model.get("id"));
        var deferred = When.defer();
        loader.start();
        model.save(modelValues, {
          success: function () {
            loader.stop();
            deferred.resolve();
          },
          conflict: function () {
            loader.stop();
            deferred.reject();
          }
        });
        queue.push(deferred.promise);
      });
      When.all(queue).then(function () {
        if (queue.length) {
          T1.Notify("message", `${queue.length + AdminUtils.pluralize(entityType, queue.length, AdminUtils.spcOpts.BOTH)}updated successfully!`);
        } else {
          T1.Notify("warning", `No${AdminUtils.pluralize(entityType, queue.length, AdminUtils.spcOpts.BOTH)}qualified for the selected action.`);
        }
      });
    },
    createInlineLoader(id) {
      var targetDiv = `#id${id}`;
      const loader = T1.Loader.create({
        contentClass: "inline-edit-loader",
        target: targetDiv,
        spinnerConfig: {
          lines: 10,
          length: 4,
          radius: 3,
          left: 15,
          top: 4
        }
      });
      return loader;
    }
  });
});
